import { FC, ComponentType } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { MailOpenFile } from 'ui/icons/other/MailOpenFile';
import { SvgIconProps } from 'ui/icons/SvgIcon';
import { TruncateTooltip } from 'ui/utility/truncate/TruncateTooltip';
import { RenderCustomTruncateProps } from 'ui/utility/truncate/Truncate';
import { colors, fontWeights } from 'ui/theme';
import { DateDisplay } from 'modules/ai/XAI/audienceUserProfile/types/common';
import { createAnalyticsLink } from '../utils/common';

import {
  CampaignDateContainer,
  CampaignImg,
  CampaignTextContainer,
  Container,
} from './CampaignCard.styles';
import { CaptionSecondary, DateTimeUnderlineText, UnspacedBody2Bold } from '../Styles';

const AnalyticsLink = styled.a`
  font-weight: ${fontWeights.regular};
  color: #333;
`;

const renderCampaignName = ({
  children,
  truncateAttribute,
  ...rest
}: RenderCustomTruncateProps) => (
  <UnspacedBody2Bold {...rest} {...truncateAttribute}>
    {children}
  </UnspacedBody2Bold>
);

export interface CampaignDataProps extends DateDisplay {
  eventData: string;
  EventIcon: ComponentType<React.PropsWithChildren<SvgIconProps>>;
  id: number;
  imgSrc: string;
  name: string;
}
export const CampaignData: FC<React.PropsWithChildren<CampaignDataProps>> = ({
  date,
  eventData,
  EventIcon = MailOpenFile,
  id,
  imgSrc,
  name,
  relativeDate,
}) => {
  return (
    <Container data-test="brand-affinity-xai-campaign-data">
      <CampaignImg src={imgSrc} height={50} width={60} alt={`campaign preview`} />
      <CampaignTextContainer>
        <TruncateTooltip
          link={createAnalyticsLink(id)}
          LinkComponent={AnalyticsLink}
          name={name}
          maxWidth={250}
          renderCustomContent={renderCampaignName}
        />
        <CampaignDateContainer>
          <EventIcon
            height={20}
            width={20}
            color={colors.grey35}
            data-test={`${eventData}_${name}_icon`}
          />
          <CaptionSecondary>{eventData}</CaptionSecondary>
          <Tooltip tooltipContent={date}>
            <DateTimeUnderlineText>{relativeDate}</DateTimeUnderlineText>
          </Tooltip>
        </CampaignDateContainer>
      </CampaignTextContainer>
    </Container>
  );
};
